export default "__VITE_ASSET__Bk9emq0j__"